




























import { Component, Prop, Vue } from 'vue-property-decorator'
import NavBarStore from '../stores/NavBar'
import StatusStore from '../stores/Status'

const component: Object = {
  store: {
    NavBarStore,
    StatusStore,
  },
}

@Component(component)

export default class ComponentStatus extends Vue {
  stores: any = {
    navBar: (this.$store as any).NavBarStore,
    status: (this.$store as any).StatusStore,
  }

  get acao() {
    return this.stores.status.getters.ACAO
  }

  get ativo() {
    return this.stores.status.getters.ATIVO
  }

  get navBarShow() {
    return this.stores.navBar.getters.SHOW
  }

  get show() {
    return this.stores.status.getters.SHOW
  }

  get texto() {
    return this.stores.status.getters.TEXTO
  }

  get textoAcao() {
    return this.stores.status.getters.TEXTO_ACAO
  }

  fechar() {
    this.stores.status.commit('SHOW', false)
  }
}
